import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { loginPathFor } from '../utils/returnTo';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, isLoading, signedOut } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-secondary-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-primary-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-secondary-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Someone who asked for a page without being signed in comes back to it after signing in. Someone who
  // chose to sign out starts clean: the next person to sign in here should not land on the page they left.
  if (!user) {
    return <Navigate to={signedOut ? '/login' : loginPathFor(location.pathname + location.search + location.hash)} replace />;
  }

  // Task 6: if the user's password is temporary, gate everything behind the
  // change-password screen — except the change-password screen itself.
  if (user.mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
